export default __webpack_public_path__ + "static/media/time.6467061e.svg";